import 'babel-polyfill';
import { hashHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';

import Root from 'shared/containers/root';
import routes from 'widget/routes';
import configureStore from 'widget/redux/configure-store';
import { setupEnv } from 'shared/env/setup-env';
import { initNewRelic } from 'shared/analytics/new-relic';
import { addSingleMeasurement } from 'shared/utils/performance';
import applicationNames from 'shared/constants/application-names';

initNewRelic({ application: applicationNames.WIDGET });
addSingleMeasurement('appRenderStart');
setupEnv();

const store = configureStore({
  configuration: {
    applicationName: applicationNames.WIDGET,
  },
});
const history = syncHistoryWithStore(hashHistory, store);

// Render the React application to the DOM
ReactDOM.render(
  <Root history={history}
        routes={routes}
        store={store} />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/widget/widget.js